export const en = {
  landingPageForNonprofits: {
    nonprofitHero: {
      title: {
        structure: "prefix_heading_suffix", // indicates word order
        prefix: "Find your next",
        suffix: "volunteer"
      },
      description: "Tap into a network of thousands of talented corporate volunteers, for free",
      gallery: {
        alt: "Gallery of volunteer activities"
      }
    },
    nonprofitLogoGrid: {
      description: "Join other nonprofits that want to change the world for good",
      logos: {
        happyHerd: "The Happy Herd logo",
        dressForSuccess: "Dress for Success logo",
        makeAWish: "Make-A-Wish logo",
        ywca: "YWCA Metro Vancouver logo",
        quest: "Quest logo",
        jericho: "Jericho Stewardship Group logo"
      }
    },
    features: {
      item1: {
        title: "Reach Thousands of Corporate Volunteers",
        paragraph1: "Employees around the world want to help you take on single-day projects. From painting, landscaping, cleanups, and cooking, we're ready to do it all!"
      },
      buttons: {
        getInTouch: "Get in touch today",
        getStarted: "Get started today"
      }
    },
    caseStudies: {
      title: "Case Studies",
      description: "Read about our work with impactful nonprofits",
      viewMore: "View more"
    },
    stats: {
      title: "Nonprofits that work with us have seen some incredible results",
      description: "We've been helping nonprofits connect with local companies to tackle meaningful projects. They're fun, rewarding, and best of all, impactful!",
      items: {
        volunteerHours: {
          title: "Volunteer Hours",
          description: "When people volunteer for great causes, the hours start to stack up quickly."
        },
        volunteers: {
          title: "Volunteers",
          description: "There have been over {count} sign ups for volunteer opportunities from over a dozen companies!"
        },
        impact: {
          title: "Financial Impact",
          description: "Volunteering is placed at $32 per hour — that means our volunteers have an equivalent dollar amount of over {amount}."
        }
      }
    }
  }
}